export const UrlUtil = {
  setQueryString(url: string, name: string, value: string): string {
    const fragDelimiterIdx = url.indexOf("#");

    const fragment = fragDelimiterIdx === -1 ?
      "" :
      url.substring(fragDelimiterIdx);

    const withoutFrag = fragDelimiterIdx === -1 ?
      url :
      url.substring(0, fragDelimiterIdx);

    const qsDelimiterIdx = withoutFrag.indexOf("?");

    if (qsDelimiterIdx === -1) {
      return withoutFrag + "?" +
        encodeURIComponent(name) + "=" +
        encodeURIComponent(value) +
        fragment;
    }

    const lcName = name.toLowerCase();
    const qs = withoutFrag.substring(qsDelimiterIdx + 1).split("&").map(kvp => {
      const pair = kvp.split("=");

      return {
        name: decodeURIComponent(pair[0] || ""),
        value: decodeURIComponent(pair[1] || "")
      };
    }).filter(kvp => kvp.name.toLowerCase() !== lcName);

    qs.push({ name, value });

    const updated = qs
      .map(kvp =>
        encodeURIComponent(kvp.name) + "=" +
        encodeURIComponent(kvp.value))
      .join("&");

    return withoutFrag.substring(0, qsDelimiterIdx) + "?" + updated + fragment;
  },

  getQueryString(): Map<string, string[]> {
    return window.location.search
      .substring(1)
      .split("&")
      .map(kvp => {
        const split = kvp.split("=");
        const name = decodeURIComponent(split[0]);
        const value = decodeURIComponent(split[1]);

        return { name, value };
      })
      .reduce(
        (map, pair) => {
          const value = map.get(pair.name) || [];
          value.push(pair.value);
          map.set(pair.name, value);

          return map;
        },
        new Map<string, string[]>());
  },
  externalUrlCheck(): void {
    const allAElementsInDiv = $("div").find("a");
    if(typeof(allAElementsInDiv) === "undefined") return;
    allAElementsInDiv.filter(index => {
      // wrapping this in a try catch to handle bad hrefs (e.g. href="this is a title")
      try {
      const anchor = allAElementsInDiv[index] as HTMLAnchorElement;
      if (anchor.href.indexOf("javascript") >= 0) { return false; }
      if (anchor.href === "#") { return false; }

      return anchor.hostname.indexOf("healio.com") < 0;
      }
      catch(error){
        console.error(error)
        return false;
      }
    })
      .attr("target", "_blank");
  }
};
